// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorBar_errorContainer__H+rqE","icon":"errorBar_icon__iTxEP","message":"errorBar_message__yXjKJ"};